// Allowlist of { macroKey: parameterName[] } for analytics logging
export var ALLOWED_LOGGED_MACRO_PARAMS = {
  children: ['all', 'first', 'depth', 'style', 'excerptType', 'sort', 'reverse'],
  'recently-updated': ['width', 'types', 'max', 'theme', 'showProfilePic', 'hideHeading'],
  excerpt: ['hidden']
};
export var ALLOWED_PARAM_TYPES = ['enum', 'number', 'boolean'];
export var CONFIG_PANEL_WIDTH = 320;
export var CONFIG_PANEL_ID = 'extensions-panel';